export default "__VITE_ASSET__zbOlfefH__"